import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { debounce } from '../../../../ts/react/common/utils/helperUtils';
import HoverGameTile from '../../gameTile/components/HoverGameTile';
import gamesPageLayout from '../constants/layoutConstants';

function HoverTileContainer({ game, gameTileRef, cursor, index, numGamesFitted, ...props }) {
  const isFirstTile = index === cursor;
  const isLastTile = index === cursor + numGamesFitted - 1;
  const isVisibleTile = index >= cursor && index <= cursor + numGamesFitted - 1;
  const [isFocused, setIsFocused] = useState(false);

  const [onBlur, cancelOnBlur] = debounce(() => {
    setIsFocused(false);
  }, 100);

  const [setFocusedForVisibleTile, cancelSetFocusedForVisibleTile] = debounce(() => {
    if (isVisibleTile) {
      setIsFocused(true);
    }
  }, 100);

  return (
    <li
      className={classNames(
        'list-item hover-game-tile',
        { 'first-tile': isFirstTile },
        { 'last-tile': isLastTile },
        { focused: isFocused }
      )}
      onMouseOver={setFocusedForVisibleTile}
      onMouseLeave={() => {
        cancelSetFocusedForVisibleTile();
        setIsFocused(false);
      }}
      onFocus={() => {
        cancelOnBlur();
        setFocusedForVisibleTile();
      }}
      onBlur={onBlur}
      id={game?.universeId}>
      {game?.universeId && (
        <HoverGameTile
          game={game}
          isFocused={isFocused}
          pageType={gamesPageLayout.pageType.gameCarousel}
          ref={gameTileRef}
          index={index}
          {...props}
        />
      )}
    </li>
  );
}

HoverTileContainer.propTypes = {
  game: PropTypes.shape({ universeId: PropTypes.number }).isRequired,
  gameTileRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
  cursor: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  numGamesFitted: PropTypes.number.isRequired,
  sortApiParams: PropTypes.shape({ hasMoreRows: PropTypes.bool }).isRequired,
  pageContext: PropTypes.shape({ pageId: PropTypes.string }).isRequired,
  sortPosition: PropTypes.number.isRequired,
  sortName: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired
};

export default HoverTileContainer;
